import {Route} from "../../../registry/routes.js"
import renameFolder from "../../../components/actions/RenameFolder.vue";

const r = new Route("rename-folder", "rename/:id", {"rename-folder": renameFolder}, {componentType:"bin_modal_component",title:"Rename"}, [], true, null)

export default r